import { Typography } from "@mui/material";
import PageWrapper from "components/PageWrapper";
import { useHistory } from "react-router";
import { MentorshipGroupList } from "./MentorshipGroupList";

export const AddOnMentorshipGroupPage = () => {
    const history = useHistory();
    return (
        <PageWrapper>
            <Typography variant="h2">Add a mentorship group to deepen your practice.</Typography>

            <Typography variant="body1">
                Meet regularly with a small group and a teacher to learn, support each other, and
                keep your practice consistent.
            </Typography>

            <MentorshipGroupList />
        </PageWrapper>
    );
};
